import { userSchema } from '@wix/da-shared-react/pkg/redux/normalizr/schemas/user';
import { createModuleStreamFetcher } from './createModuleStreamFetcher';

export default createModuleStreamFetcher({
  url: '/module/group_members',
  schema: userSchema,
});
